import React from 'react';
import { SideSheet, SideSheetProps, TabPanels, Tabs, TabList, TabPanel, Tab, Flex } from 'pounceV2';
import LogProviderIconByLogTypeV3 from 'Pages/Configure/components/LogProviderIconByLogTypeV3';
import SchemaViewerTabPanelV3 from './SchemaViewerTabPanelV3';

export type SchemaViewerSidesheetProps = {
  schemaNames: string[];
} & SideSheetProps;

const SchemaViewerSidesheetV3 = ({ schemaNames, open, onClose }: SchemaViewerSidesheetProps) => {
  const tabs = schemaNames.map(name => (
    <Tab key={name}>
      <Flex align="center" gap={2}>
        <LogProviderIconByLogTypeV3 logType={name} />
        {name}
      </Flex>
    </Tab>
  ));

  const tabPanels = schemaNames.map(name => (
    <TabPanel key={name} lazy>
      <SchemaViewerTabPanelV3 schemaName={name} />
    </TabPanel>
  ));

  return (
    <SideSheet width="40%" aria-label="schema viewer" open={open} onClose={onClose} hideDismissIcon>
      <Tabs variant="underline">
        <TabList>{tabs}</TabList>
        <TabPanels>{tabPanels}</TabPanels>
      </Tabs>
    </SideSheet>
  );
};

export default SchemaViewerSidesheetV3;
